/* globals define */
/*
  Purpose:
    - UI controller for the Specials Flyout navigation list.

  Dependencies
    - Mustache
    - jQuery
    - header.data
*/
/* eslint-disable */
(function closure(root, factory) {
/*eslint-enable*/
  /* istanbul ignore else  */
  if (typeof define === 'function' && define.amd) {
    define('header.specialsflyout', ['jquery', 'mustache', 'header.data', 'text!specialsWebFlyoutTpl', 'header.analytics'],
      function load(jQuery, Mustache, headerData, specialsFlyoutWebTemplate, headerAnalytics) {
        return factory(root, jQuery, Mustache, headerData, specialsFlyoutWebTemplate, headerAnalytics);
      });
  } else {
    // For non-AMD module, expose this to global (will also be useful for test cases)
    /*eslint-disable*/
    var _hfapp = THD.Utility.Namespace.createNamespace('THD.HFApp');
    _hfapp.flyoutSpecials = factory(root, jQuery, Mustache, THD.HFApp.data, specialsFlyoutWebTemplate, headerAnalytics);
    /*eslint-enable*/
  }
})(this, function factory(root, $, Mustache, headerData, specialsFlyoutWebTemplate, headerAnalytics) {
  var specialsFlyout = {};
  var specialsFlyoutData;
  var privateMethods = {};

  privateMethods.specialsFlyoutJsonPath = '/hdus/en_US/DTCCOMNEW/fetch/specials-flyout.json';
  privateMethods.specialsFlyoutJsonDynamicPath = '/SpecialBuy/specials-flyout';

  privateMethods.renderSubnav = function _renderSubnav() {
    if (specialsFlyoutData) {
      $('.specialOffersFlyout').html(Mustache.render(specialsFlyoutWebTemplate, specialsFlyoutData));
    }
  };

  privateMethods.updateSavingsByDepartmentData = function _updateSavingsByDepartmentData() {
    for (var index = 0; index < specialsFlyoutData.specialsflyout.links.length; index++) {
      var link = specialsFlyoutData.specialsflyout.links[index];
      if (link.title === 'Savings By Department') {
        var colCount = 1;
        var sublink = {};
        for (var sublinkIndex = 0; sublinkIndex < link.sublinks.length; sublinkIndex++) {
          if (!sublink['col' + colCount]) {
            sublink['col' + colCount] = [];
          }
          sublink['col' + colCount].push(link.sublinks[sublinkIndex]);
          if ((sublinkIndex + 1) % 3 === 0) {
            colCount++;
          }
        }
        link.sublinks = sublink;
        break;
      }
    }
  };

  privateMethods.getFlyoutData = function _getFlyoutData() {
    if (!specialsFlyoutData) {
      privateMethods.getFlyoutDataAll(function (flyoutData) {
        specialsFlyoutData = flyoutData;
        privateMethods.updateSavingsByDepartmentData();
        privateMethods.renderSubnav();
      });
    } else {
      privateMethods.renderSubnav();
    }
  };

  privateMethods.getUpdatedSpecialsData = function _getUpdatedSpecialsData() {
    return specialsFlyoutData;
  };

  privateMethods.setUpdatedSpecialsData = function _setUpdatedSpecialsData(newSpecialsFlyoutData) {
    specialsFlyoutData = newSpecialsFlyoutData;
  };

  privateMethods.validateAndUpdateFlyoutData = function _validateAndUpdateFlyoutData(flyoutData) {
    var specialBuyResponse = flyoutData.dynamicSpecialFlyoutData;
    if (!specialBuyResponse || !specialBuyResponse.featuredSavings || !specialBuyResponse.featuredSavings.links || specialBuyResponse.featuredSavings.links.length === 0 || !specialBuyResponse.featuredSavings.image) {
      flyoutData.specialsflyout.links[1].isDisabled = true;
    }
    flyoutData.specialsflyout.links[2].sublinks.forEach((link) => {
      if (link.link === 'https://www.homedepot.com/c/Savings_Center') {
        link.isSpecOff = true;
      }
    });
  };

  privateMethods.getFlyoutDataAll = function _getFlyoutDataAll(callback) {
    /* eslint-disable */
    var flyoutDataRetrieved = $.Deferred();
    /* eslint-enable */

    flyoutDataRetrieved.then(function (flyoutData) {
      callback(flyoutData);
    });

    var responseDataPromise = headerData.getEtchJSON(privateMethods.specialsFlyoutJsonPath);
    var responseDataDynnamicPromise = privateMethods.getDynamicEtchJSON(privateMethods.specialsFlyoutJsonDynamicPath);
    var flyoutData = {};
    responseDataPromise.then(function _responseDataPromise(jsonResponse) {
      flyoutData = jsonResponse;
      responseDataDynnamicPromise.then(function _responseDataDynamicPromise(jsonDynamicResponse) {
        flyoutData.dynamicSpecialFlyoutData = jsonDynamicResponse;
        privateMethods.validateAndUpdateFlyoutData(flyoutData);
        flyoutDataRetrieved.resolve(flyoutData);
      }).fail(function _responseDataDynamicError() {
        privateMethods.validateAndUpdateFlyoutData(flyoutData);
        flyoutDataRetrieved.resolve(flyoutData);
      });
    });
  };

  privateMethods.getDynamicEtchJSON = function _getDynamicEtchJSON(jsonPath) {
    /* eslint-disable */
    var loadDataDefer = $.Deferred();
    /* eslint-enable */
    var hostName = headerData.getHostName();
    var ajaxUrl = '//' + hostName + jsonPath;
    $.ajax({
      dataType: 'json',
      url: ajaxUrl,
      cache: true,
      timeout: 3000,
      success: function (data) {
        loadDataDefer.resolve(data);
      },
      error: function () {
        loadDataDefer.reject('Failed to load flyout data.');
      }
    });
    return loadDataDefer.promise();
  };

  privateMethods.logEventClick = function _logEventClick(event) {
    if (event.currentTarget.href) {
      var selectedText = $(this).text().replace('&', 'and').toLowerCase().trim()
      if ($(this).parents('.specialOffersFlyout__FeatureSavings').length) {
        selectedText = 'featured savings';
      } else if ($(this).attr('class') === 'sbotd_imgLink' || $(this).attr('class').includes('sbotd_tagline')) {
        selectedText = 'special buy of the day';
      } else if ($(this).attr('class') === 'savingsEventsImg') {
        selectedText = 'special event';
      }
      var pathArray =  ['header', 'specials and offers', selectedText].join('>');
      return headerAnalytics.logEvent('header click', pathArray);
    }
  };

  privateMethods.triggerHoverIntent = function _triggerHoverIntent() {
    $(this).trigger({
      type: 'hoverintent',
      target: this
    });
  };

  privateMethods.initialize = function _initialize() {
    $(document)
      .on('click touchend hoverintent', '.Header3 .ShoppingLinks__link[data-id="specialOffers"]', privateMethods.getFlyoutData)
      .on('click', '.specialOffersFlyout__level2link', privateMethods.logEventClick)
      .on('click', '.specialOffersFlyout__titlelink', privateMethods.logEventClick)
      .on('click', '.sbotd_imgLink', privateMethods.logEventClick)
      .on('click', '.featuredSavings_imgLink', privateMethods.logEventClick)
      .on('click', '.savingsEventsImg', privateMethods.logEventClick)
      .hoverIntent({
        selector: '.Header3 .ShoppingLinks__link[data-id="specialOffers"]',
        over: privateMethods.triggerHoverIntent,
        out: $.noop
      });
  };

  /*
   * Public Methods
   */
  specialsFlyout.init = function init() {
    privateMethods.initialize();
    headerData.init();

    return this;
  };

  specialsFlyout.getPrivateMethods = function getPrivateMethods() {
    return privateMethods;
  };

  specialsFlyout.getFlyoutData = function getFlyoutData(callback) {
    return privateMethods.getFlyoutDataAll(callback);
  };

  return specialsFlyout;
});
